import { useEffect, useState } from 'react';

const useCountdown = (
  targetDate: string | number | Date,
  timestamp: number
) => {
  const countDownDate = new Date(targetDate).getTime();
  const _timestamp = timestamp ? timestamp : new Date().getTime();

  const [countDown, setCountDown] = useState(countDownDate - _timestamp);

  useEffect(() => {
    setCountDown(countDownDate - _timestamp);
  }, [targetDate, timestamp]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown((prevState) => prevState - 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate, _timestamp]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown: number) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};

export { useCountdown, getReturnValues };
